import QuoterBricksError from './CalculateQuoterBricksError';
class BrickQuantityExceedsAvailable extends QuoterBricksError {
    constructor() {
        super('Brick quantity exceeds available');
    }
}
export default BrickQuantityExceedsAvailable;
